import { render, staticRenderFns } from "./ArchiveVideos.vue?vue&type=template&id=5fdb7509"
import script from "./ArchiveVideos.vue?vue&type=script&lang=js"
export * from "./ArchiveVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports